<div class="modal-header">
	<h4 class="modal-title fw-bold">
		<span jhiTranslate="edit-list-metadata.header"></span>
	</h4>
	<button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
			(click)="closeModal()" [disabled]="isLoading">
	</button>
</div>
<div class="modal-body">
	<div class="row">
		<div class="col">
			<h5 jhiTranslate="edit-list-metadata.details-section-title"></h5>
			<br/>
			<form name="form" #f="ngForm">
				<div class="mb-3 row">
					<label for="name" class="col-sm-3 col-form-label" jhiTranslate="edit-list-metadata.name"></label>
					<div class="col-sm-9">
						<input type="text" class="form-control" id="name" name="name" [(ngModel)]="model.listName" jhi-forbiddenCharactersValidator data-test="name" required />
					</div>
				</div>
				<div class="mb-3 row">
					<label for="description" class="col-sm-3 col-form-label" jhiTranslate="edit-list-metadata.description"></label>
					<div class="col-sm-9">
						<input type="text" class="form-control" id="description" name="description" [(ngModel)]="model.description" jhi-forbiddenCharactersValidator/>
					</div>
				</div>
				<div class="mb-3 row">
					<label for="type" class="col-sm-3 col-form-label" jhiTranslate="edit-list-metadata.type"></label>
					<div class="col-sm-9">
						<select class="form-select" name="dropdownTypes" id="dropdownTypes" [(ngModel)]="model.listType" #dropdownTypes="ngModel" required>
							<option *ngFor="let type of listTypes" [value]="type.code">
								<label>{{type.name}}</label>
							</option>
						</select>
					</div>
				</div>
				<div class="mb-3 row">
					<label for="type" class="col-sm-3 col-form-label" jhiTranslate="edit-list-metadata.date"></label>
                    <div class="col-sm-9">
                        <div class="input-group">
                            <input class="form-control" [placeholder]="'global.date.placeholder' | translate" [(ngModel)]="selectedDate"
                                   ngbDatepicker #date="ngbDatepicker" id="date" name="date" required/>
                            <button class="btn btn-outline-secondary calendar" (click)="date.toggle()" type="button"><i
                                    class="fa fa-calendar"></i></button>
                        </div>
                    </div>
				</div>
				<div class="mb-3 row">
					<label for="notes" class="col-sm-3 col-form-label" jhiTranslate="edit-list-metadata.notes"></label>
					<div class="col-sm-9">
						<textarea type="text" class="form-control" id="notes" name="notes" [(ngModel)]="model.notes" #notes="ngModel" jhi-forbiddenCharactersValidator
							   rows="4" [ngClass]="{ 'is-invalid': notes.invalid }"></textarea>
						@if (notes.invalid) {
							<small class="form-text text-danger col-4"
								   jhiTranslate="edit-list-metadata.validation-notes-have-special-characters"></small>
						}
					</div>
				</div>
			</form>
		</div>
	</div>
</div>
<div class="modal-footer">
	<button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="closeModal()" [disabled]="isLoading">
		<span class="fa fa-ban"></span>&nbsp;<span jhiTranslate="cancel"></span>
	</button>
	<button (click)="save()" [disabled]="!isFormValid(f)" class="btn btn-primary" data-test="saveList">
		<span *ngIf="isLoading" class="throbber throbber-btn"></span>
		<span class="fa fa-save"></span>&nbsp;<span jhiTranslate="save"></span>
	</button>
</div>

